import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { HrTokenService } from './hr-token.service';

@Injectable({
  providedIn: 'root',
})

export class HrAuthStateService {
  private userState = new BehaviorSubject<boolean>(this.token.isLoggedIn()!);
  userAuthState = this.userState.asObservable();
  constructor(public token: HrTokenService) {}
  setAuthState(value: boolean) {
    this.userState.next(value);
  }
}